/* TIME 2 TASTE — Welle 1 — Mehr-lesen + FAQ-Akkordeon-Toggle */
(function () {
  'use strict';

  function initSeoMore() {
    var blocks = document.querySelectorAll('.t2t-seo-block');
    blocks.forEach(function (block) {
      var text = block.querySelector('[data-t2t-seo-text]');
      var btn = block.querySelector('[data-t2t-seo-more]');
      if (!text || !btn || btn.dataset.t2tInit === '1') return;
      btn.dataset.t2tInit = '1';
      // Nur einblenden, wenn Text wirklich abgeschnitten ist
      if (text.scrollHeight > text.clientHeight + 2) {
        btn.classList.add('is-active');
      }
      btn.addEventListener('click', function () {
        var expanded = text.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded ? 'Weniger anzeigen' : 'Mehr lesen…';
      });
    });
  }

  function initFaqAccordion() {
    var items = document.querySelectorAll('.t2t-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.t2t-faq__q');
      if (!btn || btn.dataset.t2tInit === '1') return;
      btn.dataset.t2tInit = '1';
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // Akkordeon-Verhalten: andere zuklappen
        var list = item.parentElement;
        if (list) {
          list.querySelectorAll('.t2t-faq__item.is-open').forEach(function (other) {
            other.classList.remove('is-open');
            var otherBtn = other.querySelector('.t2t-faq__q');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function initFaqMoreToggle() {
    // Greift Welle-1-FAQ-Listen (.t2t-faq__list) und Tastings-Legacy (.to-faq__list).
    // Erste 5 FAQs sichtbar, Rest hinter "Mehr anzeigen"-Button.
    // Volltext bleibt im DOM (SEO + JSON-LD-Schema).
    var lists = document.querySelectorAll('.t2t-faq__list, .to-faq__list');
    lists.forEach(function (list) {
      if (list.dataset.t2tFaqMoreInit === '1') return;
      var items = list.querySelectorAll(':scope > .t2t-faq__item, :scope > .to-faq__item');
      if (items.length <= 5) return;
      list.dataset.t2tFaqMoreInit = '1';

      items.forEach(function (item, idx) {
        if (idx >= 5) item.classList.add('is-faq-hidden');
      });

      var hidden = items.length - 5;
      var showText = 'Mehr anzeigen (' + hidden + ' weitere)';
      var hideText = 'Weniger anzeigen';
      var iconSvg = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 't2t-faq-more-btn';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = '<span class="t2t-faq-more-btn__label">' + showText + '</span> ' + iconSvg;

      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        items.forEach(function (item, idx) {
          if (idx >= 5) {
            if (expanded) item.classList.add('is-faq-hidden');
            else item.classList.remove('is-faq-hidden');
          }
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        var label = btn.querySelector('.t2t-faq-more-btn__label');
        if (label) label.textContent = expanded ? showText : hideText;
      });

      var wrap = document.createElement('div');
      wrap.className = 't2t-faq-more-wrap';
      wrap.appendChild(btn);
      list.parentNode.insertBefore(wrap, list.nextSibling);
    });
  }

  function init() {
    initSeoMore();
    initFaqAccordion();
    initFaqMoreToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init bei Theme-Editor-Updates (Shopify Customize-Editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
